import { useCallback, useMemo } from "react";

import { useSearchParams } from "react-router-dom";

import { mutateSearchParam } from "@/helpers/search_params/search_params.helpers";
import { ADVANCED_SEARCH_NAME } from "./advanced_search.constants";
import {
  AdvancedSearchFilters,
  AdvancedSearchParams,
} from "./advanced_search.decl";

export const useAdvanceSearchState = () => {
  const [searchParam, setSearchParam] = useSearchParams();

  const setAdvancedSearch = useCallback(
    (val?: AdvancedSearchParams) => {
      mutateSearchParam(
        ADVANCED_SEARCH_NAME.query,
        val?.q?.toString(),
        searchParam
      );
      mutateSearchParam(
        ADVANCED_SEARCH_NAME.said_by,
        val?.sb?.toString(),
        searchParam
      );
      setSearchParam(searchParam);
    },
    [searchParam, setSearchParam]
  );

  const advancedSearch: {
    query?: string;
    saidBy?: AdvancedSearchFilters;
  } = useMemo(() => {
    const query = searchParam.get(ADVANCED_SEARCH_NAME.query) ?? undefined;
    const saidBy = (searchParam.get(ADVANCED_SEARCH_NAME.said_by) ??
      undefined) as AdvancedSearchFilters | undefined;

    return { query, saidBy };
  }, [searchParam]);

  const hasSearch = (advancedSearch?.query?.length ?? 0) > 2;
  return { advancedSearch, setAdvancedSearch, hasSearch };
};
